import { createTheme } from '@mui/material/styles';

const { palette } = createTheme();

export const theme = createTheme({
  palette: {
    primary: palette.augmentColor({
      color: {
        main: '#151515',
      },
    }),
    secondary: {
      main: '#fc0841',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFC107',
      contrastText: '#ffffff',
    },
    success: {
      main: '#4CAF50',
      contrastText: '#ffffff',
    },
    info: {
      main: '#2196F3',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FF5722',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: '#fc0841',
        },
      },
    },
  },
});
